import { EntityExtraTagsTaskRules } from '../../EntityExtraTags'
import { ICON_HEIGHT_16 } from '../../Icon'
import { TableTitleCell } from '../../Table'
import { getTaskIconByApiName, isTaskDone } from '../Task.utils'

import InfoIcon from '../../../icons/info.svg'

function TaskTableRowTitle({ hideAutomationsTag, item, ...restProps }) {
  const {
    activity_type: activity,
    counters,
    directory_id: directoryId,
    id,
    notes,
    request,
    title,
  } = item

  const {
    icon: { name: iconName },
    name: activityName,
  } = activity

  const visibleCounters =
    counters && hideAutomationsTag
      ? { ...counters, [EntityExtraTagsTaskRules.ActiveAutomationsCount]: null }
      : counters

  const extra = visibleCounters ? { items: [{ ...visibleCounters, id }] } : null

  const done = isTaskDone(item)

  return (
    <TableTitleCell
      {...restProps}
      showIconTooltip
      avatarProps={{ Icon: getTaskIconByApiName(iconName) }}
      done={done}
      extra={extra}
      extraRules={EntityExtraTagsTaskRules}
      iconTooltip={activityName}
      id={id}
      noteProps={{
        Icon: InfoIcon,
        iconSize: ICON_HEIGHT_16,
        markup: true,
        value: notes,
      }}
      tagsProps={{
        directoryId,
        objectId: request?.id,
      }}
      value={title}
    />
  )
}

export default TaskTableRowTitle
